module.exports = __webpack_public_path__ + "static/media/Guest_Button@3x.be4e1558.png";